import axios from "axios";
import React, { useEffect, useState } from "react";
import endPoint from "../../websitecomponents/redux/EndPoint/endpoint";
import { toast } from "react-toastify";

const Wallet = () => {

    const [walletData, setWalletData] = useState({
        currentBalance: 0,
        totalCredits: 0,
        totalDebits: 0,
        transactions: [],
    });

    const [loading, setLoading] = useState(false);

    // Withdraw states
    const [showWithdrawModal, setShowWithdrawModal] = useState(false);
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [withdrawLoading, setWithdrawLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        fetchWalletData();
    }, []);

    const fetchWalletData = async () => {
        const token = localStorage.getItem("SellerTokenData");
        if (!token) return;

        try {
            setLoading(true)
            const res = await axios.get(endPoint.GetSellerWallet, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setWalletData(res.data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleWithdrawSubmit = async () => {
        setError("");
        if (!withdrawAmount || withdrawAmount <= 0) {
            setError("Enter valid amount");
            return;
        }

        if (withdrawAmount > walletData.currentBalance) {
            setError("Amount exceeds wallet balance");
            return;
        }

        try {
            setWithdrawLoading(true);
            const res = await axios.post(
                endPoint.SellerWithdraw,
                {
                    amount: Number(withdrawAmount)
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("SellerTokenData")}`,
                    },
                }
            );
            toast.success("Withdraw request submitted successfully");
            setShowWithdrawModal(false);
            setWithdrawAmount("");
            fetchWalletData();
        } catch (error) {
            setError(
                error?.response?.data?.message ||
                "Withdraw failed"
            );
        } finally {
            setWithdrawLoading(false);
        }
    };

    if (loading) return <div className="p-6">Loading...</div>;

    return (
        <div className="p-6 mx-auto">

            <div className="border rounded-lg p-4 mb-6 bg-white">
                <div className="flex justify-between items-center">
                    <div>
                        <p className="text-gray-500 text-sm">
                            Todays  Earnings
                        </p>

                        <p className="text-2xl font-semibold">
                            ₹{walletData.currentBalance}
                        </p>
                    </div>

                    {/* <button
                        onClick={() => setShowWithdrawModal(true)}
                        className="border px-4 py-2 rounded hover:bg-gray-100"
                    >
                        Withdraw
                    </button> */}

                </div>

                <div className="mt-3 text-sm text-gray-500">
                    Total Credits: ₹{walletData.totalCredits}
                </div>

                <div className="text-sm text-gray-500">
                    Total Debits: ₹{walletData.totalDebits}
                </div>

            </div>


            {/* Transactions */}
            {/* <div className="border rounded-lg bg-white">

                <div className="p-4 border-b font-medium">
                    Transactions
                </div>

                {walletData?.transactions.length === 0 ? (

                    <div className="p-4 text-gray-500">
                        No transactions found
                    </div>

                ) : (

                    walletData?.transactions.map((item) => (

                        <div
                            key={item._id}
                            className="flex justify-between items-center p-4 border-b"
                        >

                            <div>

                                <div className="text-sm font-medium">
                                    {item.description}
                                </div>

                                <div className="text-xs text-gray-500">
                                    {item.type}
                                </div>

                            </div>

                            <div className="font-medium">
                                ₹{item.amount}
                            </div>

                        </div>

                    ))

                )}

            </div> */}


            {/* Withdraw Modal */}
            {showWithdrawModal && (
                <div className="fixed inset-0 bg-gray-900 bg-opacity-40 flex justify-center items-center">
                    <div className="bg-white p-6 rounded-lg w-96">
                        <h2 className="text-lg font-semibold mb-4">
                            Withdraw Amount
                        </h2>

                        <input
                            type="number"
                            placeholder="Enter amount"
                            value={withdrawAmount}
                            onChange={(e) =>
                                setWithdrawAmount(e.target.value)
                            }
                            className="w-full border p-2 rounded mb-3"
                        />

                        {error && (
                            <div className="text-red-500 text-sm mb-2">
                                {error}
                            </div>
                        )}

                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() =>
                                    setShowWithdrawModal(false)
                                }
                                className="px-4 py-2 border rounded"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={handleWithdrawSubmit}
                                disabled={withdrawLoading}
                                className="px-4 py-2 bg-black text-white rounded"
                            >
                                {withdrawLoading
                                    ? "Processing..."
                                    : "Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default Wallet;